import { Box } from '@chakra-ui/react';
import React, { useLayoutEffect, useMemo, useState } from 'react';

function Icon({ name, width = '24px', height = '24px', ...props }: any) {
    const [isClient, setIsClient] = useState(false);

    useLayoutEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    const Icon = useMemo(
        () =>
            isClient ? React.lazy(() => import(`../Icons/${name}.js`)) : null,
        [name, isClient]
    );

    return isClient ? (
        <React.Suspense fallback={null}>
            <Box
                as={Icon}
                display="inline-block"
                width={width}
                height={height}
                {...props}
            />
        </React.Suspense>
    ) : null;
}

export default Icon;
